import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-organisation-structure',
  templateUrl: './organisation-structure.component.html',
  styleUrls: ['./organisation-structure.component.css']
})
export class OrganisationStructureComponent implements OnInit { 

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, public encDec:EncryptDecryptService,private route: Router,
    public translate: TranslateService) { }
  trevalParent: any = "";
  trevalChild: any = "";

  language = sessionStorage.getItem('locale');//dynamic
  ngOnInit(): void {
    $('.genealogy-tree ul').hide();
    $('.genealogy-tree>ul').show();
    $('.genealogy-tree ul.active').show();
    $('.regionul ul').hide();
    this.ZoneList();
  }
  
  // CLICK ACTION PARENT AND CHILD ELEMENT OF TREE STRUCTERED ELEMENTS - STARTS
  // clickAction(parent: any, child: any) {
  //   // console.log(this.trevalParent, parent);
  //   // console.log(this.trevalChild, child);
  //   if (parent != "") {      //Checking parent is blank or not
  //     if (child == "") {     //parent or child is clicked or not
  //       if (!$('.' + parent).is(':visible')) {     //Manipulation of parent (parent is not visible then,)
  //         $('.' + parent).show();     //Show parent elements
  //       } else {
  //         $('.' + parent).hide();     //Hide parent elements
  //       }
  //     } else {     //Manipulation of Child
  //       if (!$('.' + child).is(':visible')) {    //Manipulation of child (child is not visible then,)
  //         if (this.trevalChild != "") {      //checking child is there or not
  //           $('.' + this.trevalChild).hide();     //hide child elements
  //         }
  //         $('.' + child).show();     //Show child elements
  //       } else {
  //         $('.' + child).hide();     //Hide child elements
  //       }
  //     }
  //   }
  //   if (this.trevalParent != "") {      //Manipulation of different parent click
  //     if (this.trevalParent != parent) {      //checking whether clicked on same parent or different parent
  //       if (child == "") {      // Now, checking whether clicked on child or parent

  //         $('.' + this.trevalParent).hide();     // previous parent elements hide
  //         $('.' + parent).show();     // new parent show
  //       } else {
  //         if (this.trevalChild != "") {      // previous child is not active or empty
  //           $('.' + this.trevalChild).hide();      //previous child hide
  //         }

  //         $('.' + child).hide();      // new child hide
  //       }
  //     }
  //   }
  //   this.trevalParent = parent; // local body storing for parent
  //   this.trevalChild = child; // local body storing for child 
  // }
  // CLICK ACTION PARENT AND CHILD ELEMENT OF TREE STRUCTERED ELEMENTS - STARTS



 

  zone_apirespons: any;
  zoneList: any[] = [];
  ZoneList() { 
    this.zoneList = [];
    this.regionList = [];
    this.depotList = [];
    this.districtList = [];
    this.districtAnddepotList = [];
    this.httpservice.getZoneListNew().subscribe((response: HttpEvent<any>) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            if(res.original.status){
              let arr = res.original.data;
              for (let i = 0; i < arr.length; i++) {
                if(arr[i].int_Demographic_Id!==32){
                  this.zoneList.push(arr[i]);
                }
              }
            }
            
          } 
      }
    });
  }  



  region_apirespons: any;
  regionList: any[] = [];
  GetRegion(data:any){
    this.regionList = [];
    this.depotList = [];
    this.districtList = [];
    this.districtAnddepotList = [];
    $(`.region-box`).removeClass('bg-active-region');
    $(`#depotdiv`).css('display','none');
    let p = {'zone_name':data.ZONE};
    let regionul = document.getElementById('regionul'+data.vch_Code+'_'+data.id);
    $(`.zone-box`).removeClass('bg-active-zone');
    if(regionul?.style.display=="flex"){
      $(`.regionul`).css('display','none');
      $(`.region${data.vch_Code}_${data.id}`).removeClass('regionulbefore');
      // $('selector').addClass('class_name');
      // genealogy-tree
      $(`#zonebox${data.vch_Code}_${data.id}`).removeClass('bg-active-zone');
    } else {
      $(`#zonebox${data.vch_Code}_${data.id}`).addClass('bg-active-zone');
      this.httpservice.GetRegionByZoneName(p).subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.region_apirespons = response.body;
            let respData = this.region_apirespons.RESPONSE_DATA;
            let respToken = this.region_apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let res = JSON.parse(Buffer.from(respData, 'base64').toString());
              this.regionList = res.original.data;
              // console.log(this.regionList);
              $(`.regionul`).css('display','none');
              $(`.region${data.vch_Code}_${data.id}`).addClass('regionulbefore').css('display','flex');
            }
        }
      });
    }
  }



  


  depot_apirespons: any;
  depotList: any[] = [];
  currentRegion:any = {
    "id":'',
    "ZONE": '',
    "REGION":'',
    'vch_Code':'',
    "CREATED_ON":'',
    "UPDATED_ON":'',
}
  districtList: any[] = [];
  districtAnddepotList:any[] = [];
  GetDepotListFn(region:any,zone:any){
    this.depotList = [];
    this.districtList = [];
    this.districtAnddepotList = [];
    let p:any = {'REGION_NAME':region.REGION,'ZONE_NAME':zone.ZONE};
    this.httpservice.GetDistrictAndDepotByRegionName(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            // console.log(res);
            this.depotList = res.original.DEPOT_list;
            this.districtList = res.original.DISTRICT_list;
            this.districtList.forEach((element:any) => {
              this.districtAnddepotList.push({
                "id": element.id,
                "ZONE": element.ZONE,
                "REGION":element.REGION,
                "DISTRICT":element.DISTRICT,
                "DISTRICT_HN":element.DISTRICT_HN,
                'depotList':this.findMyDepotList(element.DISTRICT)
              })
            });
            
            // console.log(this.depotList);
            // console.log(this.districtList);
            // console.log(this.districtAnddepotList);
            $(`#depotdiv`).css('display','block');
            // console.log(this.depotList);
            // $(`.depotul`).css('display','none');
            // $(`.depotul${region.vch_Code}_${zone.int_Demographic_Id}`).addClass('depotulbefore').css('display','grid');
          }
      }
    });
  }


  previousVal:any = "";
  GetDepotList(region:any,zone:any){
    let divid = `regionbox${region.vch_Code}${region.id}`;
    this.currentRegion = region;
    // console.log(this.currentRegion);
    this.depotList = [];
    let p = {'REGION_CODE':region.vch_Code};
    let depotdiv = document.getElementById('depotdiv');
    $(`.region-box`).removeClass('bg-active-region');
    $(`.regionbox${region.vch_Code}_${region.id}`).addClass('bg-active-region');
    $(`#depotdiv`).css('display','none');
    if(this.previousVal==region.vch_Code){
      this.previousVal= "";
      $(`#depotdiv`).css('display','none');
      $(`.regionbox${region.vch_Code}_${region.id}`).removeClass('bg-active-region');
    } else {
      this.previousVal=region.vch_Code;
      this.GetDepotListFn(region,zone);
    }
    // if(!$(`#${divid}`).hasClass("bg-active-region")){ 
     
    //  } else {
    //   $(`#depotdiv`).css('display','none');
    //   $(`.regionbox${region.vch_Code}_${region.id}`).removeClass('bg-active-region');
    //   // this.GetDepotListFn(region,zone);
    //  }
    // if(depotdiv?.style.display=="block"){
    //    $(`#depotdiv`).css('display','none');
    //    $(`.regionbox${region.vch_Code}_${region.id}`).removeClass('bg-active-region');
    // } else { 
    //   $(`.regionbox${region.vch_Code}_${region.id}`).addClass('bg-active-region');
    //   this.GetDepotListFn(region,zone);
    // }
  }


  findMyDepotList(district:any):any{
    let depot:any[] = [];
    this.depotList.forEach((element: any) => {
      if (district == element.DISTRICT) {
        depot.push(element);
      }
    });
    return depot;
  }







LocationName(zone:any):any{
if(zone=="EAST"){
return this.language=='English'?"Kolkata":"कोलकाता";
} else if(zone=="NORTH EAST"){
  return this.language=='English'?"Guwahati":"गुवाहाटी";
} else if(zone=="NORTH"){
  return this.language=='English'?"Noida":"नोएडा";
} else if(zone=="SOUTH"){
  return this.language=='English'?"Chennai":"चेन्नई";
} else if(zone=="WEST"){
  return this.language=='English'?"Mumbai":"मुंबई";
} else {
  return "";
}
}

jumpToSection(sectionId: string) {
  const element = document.getElementById(sectionId);

  if (element) {
    // element.classList.add('scroll-target-1');
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

}
